// extracted by mini-css-extract-plugin
export default {"container":"Mian_container__2grYN","sections_container":"Mian_sections_container__8is71","user_data_container":"Mian_user_data_container__kTHRD"};